import { Fragment as e, Slice as t } from "prosemirror-model";
import { Extension as n, combineTransactionSteps as r, findChildrenInRange as i, getChangedRanges as a } from "@tiptap/core";
import { Plugin as o, PluginKey as s } from "prosemirror-state";
import { uuidv4 as c } from "lib0/random";
//#region src/extensions/tiptap-extensions/UniqueID/UniqueID.ts
function l(e, t = JSON.stringify) {
	let n = {};
	return e.filter((e) => {
		let r = t(e);
		return Object.prototype.hasOwnProperty.call(n, r) ? !1 : n[r] = !0;
	});
}
function u(e) {
	return l(e.filter((t, n) => e.indexOf(t) !== n));
}
var d = n.create({
	name: "uniqueID",
	priority: 1e4,
	addOptions() {
		return {
			attributeName: "id",
			types: [],
			setIdAttribute: !1,
			isWithinEditor: void 0,
			generateID: () => {
				if (typeof window < "u" && window.__TEST_OPTIONS) {
					let e = window.__TEST_OPTIONS;
					return e.mockID === void 0 ? e.mockID = 0 : e.mockID++, e.mockID.toString();
				}
				return c();
			}
		};
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { [this.options.attributeName]: {
				default: null,
				parseHTML: (e) => e.getAttribute(`data-${this.options.attributeName}`),
				renderHTML: (e) => {
					let t = { [`data-${this.options.attributeName}`]: e[this.options.attributeName] };
					return this.options.setIdAttribute ? {
						...t,
						id: e[this.options.attributeName]
					} : t;
				}
			} }
		}];
	},
	addProseMirrorPlugins() {
		let { isWithinEditor: n } = this.options, c = null, l = !1;
		return [new o({
			key: new s("uniqueID"),
			appendTransaction: (e, t, n) => {
				if (!(e.some((e) => e.docChanged) && !t.doc.eq(n.doc))) return;
				let { tr: o } = n, { types: s, attributeName: c, generateID: l } = this.options, d = r(t.doc, e), { mapping: f } = d;
				if (a(d).forEach(({ newRange: e }) => {
					let r = i(n.doc, e, (e) => s.includes(e.type.name)), a = u(r.map(({ node: e }) => e.attrs[c]).filter((e) => e !== null));
					r.forEach(({ node: e, pos: r }) => {
						let i = o.doc.nodeAt(r)?.attrs[c];
						if (i === null) {
							let i = t.doc.type.createAndFill().content;
							if (t.doc.content.findDiffStart(i) === null) {
								let t = JSON.parse(JSON.stringify(n.doc.toJSON()));
								if (t.content[0].content[0].attrs.id = "initialBlockId", JSON.stringify(t.content) === JSON.stringify(i.toJSON())) {
									o.setNodeMarkup(r, void 0, {
										...e.attrs,
										[c]: "initialBlockId"
									});
									return;
								}
							}
							o.setNodeMarkup(r, void 0, {
								...e.attrs,
								[c]: l()
							});
							return;
						}
						let { deleted: s } = f.invert().mapResult(r);
						s && a.includes(i) && o.setNodeMarkup(r, void 0, {
							...e.attrs,
							[c]: l()
						});
					});
				}), o.steps.length) return o.setMeta("uniqueID", !0), o;
			},
			view(e) {
				let t = (t) => {
					let r = e.dom.parentElement;
					c = r?.contains(t.target) || n?.(t.target) ? r : null;
				};
				return window.addEventListener("dragstart", t), { destroy() {
					window.removeEventListener("dragstart", t);
				} };
			},
			props: {
				handleDOMEvents: {
					drop: (e, t) => (l = c !== e.dom.parentElement || t.dataTransfer?.effectAllowed === "copy", c = null, !1),
					paste: () => (l = !0, !1)
				},
				transformPasted: (n) => {
					if (!l) return n;
					let { types: r, attributeName: i } = this.options, a = (t) => {
						let n = [];
						return t.forEach((e) => {
							if (e.isText) {
								n.push(e);
								return;
							}
							if (!r.includes(e.type.name)) {
								n.push(e.copy(a(e.content)));
								return;
							}
							let t = e.type.create({
								...e.attrs,
								[i]: null
							}, a(e.content), e.marks);
							n.push(t);
						}), e.from(n);
					};
					return l = !1, new t(a(n.content), n.openStart, n.openEnd);
				}
			}
		})];
	}
});
//#endregion
//#region src/schema/inlineContent/types.ts
function f(e) {
	return e.type === "link";
}
function p(e) {
	return typeof e != "string" && e.type === "link";
}
function m(e) {
	return typeof e != "string" && e.type === "text";
}
//#endregion
//#region src/util/typescript.ts
var h = class extends Error {
	constructor(e) {
		super(`Unreachable case: ${e}`);
	}
};
function g(e, t = !0) {
	let { "data-test": n, ...r } = e;
	if (Object.keys(r).length > 0 && t) throw Error("Object must be empty " + JSON.stringify(e));
}
//#endregion
//#region src/api/getBlockInfoFromPos.ts
function _(e, t) {
	let n = e.resolve(t);
	if (n.nodeAfter && n.nodeAfter.type.isInGroup("bnBlock")) return {
		posBeforeNode: n.pos,
		node: n.nodeAfter
	};
	let r = n.depth, i = n.node(r);
	for (; r > 0;) {
		if (i.type.isInGroup("bnBlock")) return {
			posBeforeNode: n.before(r),
			node: i
		};
		r--, i = n.node(r);
	}
	let a = [];
	e.descendants((e, t) => {
		e.type.isInGroup("bnBlock") && a.push(t);
	}), console.warn(`Position ${t} is not within a blockContainer node.`);
	let o = e.resolve(a.find((e) => e >= t) || a[a.length - 1]);
	return {
		posBeforeNode: o.pos,
		node: o.nodeAfter
	};
}
function v(e, t) {
	if (!e.type.isInGroup("bnBlock")) throw Error(`Attempted to get bnBlock node at position but found node of different type ${e.type.name}`);
	let n = e, r = t, i = {
		node: n,
		beforePos: r,
		afterPos: r + n.nodeSize
	};
	if (n.type.name === "blockContainer") {
		let e, t;
		if (n.forEach((n, i) => {
			if (n.type.spec.group === "blockContent") {
				let t = n, a = r + i + 1;
				e = {
					node: t,
					beforePos: a,
					afterPos: a + n.nodeSize
				};
			} else if (n.type.name === "blockGroup") {
				let e = n, a = r + i + 1;
				t = {
					node: e,
					beforePos: a,
					afterPos: a + n.nodeSize
				};
			}
		}), !e) throw Error(`blockContainer node does not contain a blockContent node in its children: ${n}`);
		return {
			isBlockContainer: !0,
			bnBlock: i,
			blockContent: e,
			childContainer: t,
			blockNoteType: e.node.type.name
		};
	} else {
		if (!i.node.type.isInGroup("childContainer")) throw Error(`bnBlock node is not in the childContainer group: ${i.node}`);
		return {
			isBlockContainer: !1,
			bnBlock: i,
			childContainer: i,
			blockNoteType: i.node.type.name
		};
	}
}
function y(e) {
	return v(e.node, e.posBeforeNode);
}
function b(e) {
	if (!e.nodeAfter) throw Error(`Attempted to get blockContainer node at position ${e.pos} but a node at this position does not exist`);
	return v(e.nodeAfter, e.pos);
}
function x(e) {
	return y(_(e.doc, e.selection.anchor));
}
function S(e) {
	return y(_(e.doc, e.selection.anchor));
}
//#endregion
//#region src/api/pmUtil.ts
function C(e) {
	return "doc" in e ? e.doc.type.schema : e.type.schema;
}
function w(e) {
	return e.cached.blockNoteEditor;
}
function T(e) {
	return w(e).schema;
}
function E(e) {
	return T(e).blockSchema;
}
function D(e) {
	return T(e).inlineContentSchema;
}
function O(e) {
	return T(e).styleSchema;
}
function k(e) {
	return w(e).blockCache;
}
//#endregion
//#region src/api/nodeConversions/nodeToBlock.ts
function A(e, t, n) {
	let r = {
		type: "tableContent",
		columnWidths: [],
		headerRows: void 0,
		headerCols: void 0,
		rows: []
	}, i = [];
	e.content.forEach((e, a, o) => {
		let s = { cells: [] };
		o === 0 && e.content.forEach((e) => {
			let t = e.attrs.colwidth;
			t ??= Array(e.attrs.colspan ?? 1).fill(void 0), r.columnWidths.push(...t);
		}), s.cells = e.content.content.map((e, r) => (i[o] || (i[o] = []), i[o][r] = e.type.name === "tableHeader", {
			type: "tableCell",
			content: e.content.content.map((e) => j(e, t, n)).reduce((e, t) => {
				if (!e.length) return t;
				let n = e[e.length - 1], r = t[0];
				return r && m(n) && m(r) && JSON.stringify(n.styles) === JSON.stringify(r.styles) ? (n.text += "\n" + r.text, e.push(...t.slice(1)), e) : (e.push(...t), e);
			}, []),
			props: {
				colspan: e.attrs.colspan,
				rowspan: e.attrs.rowspan,
				backgroundColor: e.attrs.backgroundColor,
				textColor: e.attrs.textColor,
				textAlignment: e.attrs.textAlignment
			}
		})), r.rows.push(s);
	});
	for (let e = 0; e < i.length; e++) i[e]?.every((e) => e) && (r.headerRows = (r.headerRows ?? 0) + 1);
	for (let e = 0; e < i[0]?.length; e++) i?.every((t) => t[e]) && (r.headerCols = (r.headerCols ?? 0) + 1);
	return r;
}
function j(e, t, n) {
	let r = [], i;
	return e.content.forEach((e) => {
		if (e.type.name === "hardBreak") {
			if (i) if (m(i)) i.text += "\n";
			else if (f(i)) i.content[i.content.length - 1].text += "\n";
			else throw Error("unexpected");
			else i = {
				type: "text",
				text: "\n",
				styles: {}
			};
			return;
		}
		if (e.type.name !== "link" && e.type.name !== "text") {
			if (!t[e.type.name]) {
				console.warn("unrecognized inline content type", e.type.name);
				return;
			}
			i &&= (r.push(i), void 0), r.push(M(e, t, n));
			return;
		}
		let a = {}, o;
		for (let t of e.marks) if (t.type.name === "link") o = t;
		else {
			let e = n[t.type.name];
			if (!e) {
				if (t.type.spec.blocknoteIgnore) continue;
				throw Error(`style ${t.type.name} not found in styleSchema`);
			}
			if (e.propSchema === "boolean") a[e.type] = !0;
			else if (e.propSchema === "string") a[e.type] = t.attrs.stringValue;
			else throw new h(e.propSchema);
		}
		i ? m(i) ? o ? (r.push(i), i = {
			type: "link",
			href: o.attrs.href,
			content: [{
				type: "text",
				text: e.textContent,
				styles: a
			}]
		}) : JSON.stringify(i.styles) === JSON.stringify(a) ? i.text += e.textContent : (r.push(i), i = {
			type: "text",
			text: e.textContent,
			styles: a
		}) : f(i) && (o ? i.href === o.attrs.href ? JSON.stringify(i.content[i.content.length - 1].styles) === JSON.stringify(a) ? i.content[i.content.length - 1].text += e.textContent : i.content.push({
			type: "text",
			text: e.textContent,
			styles: a
		}) : (r.push(i), i = {
			type: "link",
			href: o.attrs.href,
			content: [{
				type: "text",
				text: e.textContent,
				styles: a
			}]
		}) : (r.push(i), i = {
			type: "text",
			text: e.textContent,
			styles: a
		})) : i = o ? {
			type: "link",
			href: o.attrs.href,
			content: [{
				type: "text",
				text: e.textContent,
				styles: a
			}]
		} : {
			type: "text",
			text: e.textContent,
			styles: a
		};
	}), i && r.push(i), r;
}
function M(e, t, n) {
	if (e.type.name === "text" || e.type.name === "link") throw Error("unexpected");
	let r = {}, i = t[e.type.name];
	for (let [t, n] of Object.entries(e.attrs)) {
		if (!i) throw Error("ic node is of an unrecognized type: " + e.type.name);
		t in i.propSchema && (r[t] = n);
	}
	let a;
	return a = i.content === "styled" ? j(e, t, n) : void 0, {
		type: e.type.name,
		props: r,
		content: a
	};
}
function N(e, t, n = E(t), r = D(t), i = O(t), a = k(t)) {
	if (!e.type.isInGroup("bnBlock")) throw Error("Node should be a bnBlock, but is instead: " + e.type.name);
	let o = a?.get(e);
	if (o) return o;
	let s = v(e, 0), c = s.bnBlock.node.attrs.id;
	c === null && (c = d.options.generateID());
	let l = n[s.blockNoteType];
	if (!l) throw Error("Block is of an unrecognized type: " + s.blockNoteType);
	let u = {};
	for (let [t, n] of Object.entries({
		...e.attrs,
		...s.isBlockContainer ? s.blockContent.node.attrs : {}
	})) {
		let e = l.propSchema;
		t in e && !(e[t].default === void 0 && n === void 0) && (u[t] = n);
	}
	let f = n[s.blockNoteType], p = [];
	s.childContainer?.node.forEach((e) => {
		p.push(N(e, t, n, r, i, a));
	});
	let m;
	if (f.content === "inline") {
		if (!s.isBlockContainer) throw Error("impossible");
		m = j(s.blockContent.node, r, i);
	} else if (f.content === "table") {
		if (!s.isBlockContainer) throw Error("impossible");
		m = A(s.blockContent.node, r, i);
	} else if (f.content === "none") m = void 0;
	else throw new h(f.content);
	let g = {
		id: c,
		type: f.type,
		props: u,
		content: m,
		children: p
	};
	return a?.set(e, g), g;
}
function P(e, t = C(e), n = E(t), r = D(t), i = O(t), a = k(t)) {
	let o = [];
	return e.firstChild && e.firstChild.descendants((e) => (o.push(N(e, t, n, r, i, a)), !1)), o;
}
function F(e, t, n = E(t), r = D(t), i = O(t), a = k(t)) {
	function o(e, s, c) {
		if (e.type.name !== "blockGroup") throw Error("unexpected");
		let l = [], u, d;
		return e.forEach((f, p, m) => {
			if (f.type.name !== "blockContainer") throw Error("unexpected");
			if (f.childCount === 0) return;
			if (f.childCount === 0 || f.childCount > 2) throw Error("unexpected, blockContainer.childCount: " + f.childCount);
			let h = m === 0, g = m === e.childCount - 1;
			if (f.firstChild.type.name === "blockGroup") {
				if (!h) throw Error("unexpected");
				let e = o(f.firstChild, Math.max(0, s - 1), g ? Math.max(0, c - 1) : 0);
				u = e.blockCutAtStart, g && (d = e.blockCutAtEnd), l.push(...e.blocks);
				return;
			}
			let _ = N(f, t, n, r, i, a), v = f.childCount > 1 ? f.child(1) : void 0, y = [];
			if (v) {
				let e = o(v, 0, g ? Math.max(0, c - 1) : 0);
				y = e.blocks, g && (d = e.blockCutAtEnd);
			}
			g && !v && c > 1 && (d = _.id), h && s > 1 && (u = _.id), l.push({
				..._,
				children: y
			});
		}), {
			blocks: l,
			blockCutAtStart: u,
			blockCutAtEnd: d
		};
	}
	if (e.content.childCount === 0) return {
		blocks: [],
		blockCutAtStart: void 0,
		blockCutAtEnd: void 0
	};
	if (e.content.childCount !== 1) throw Error("slice must be a single block, did you forget includeParents=true?");
	return o(e.content.firstChild, Math.max(e.openStart - 1, 0), Math.max(e.openEnd - 1, 0));
}
//#endregion
export { m as C, p as S, v as _, M as a, g as b, T as c, C as d, O as f, S as g, x as h, N as i, E as l, b as m, A as n, F as o, y as p, P as r, k as s, j as t, D as u, _ as v, d as w, f as x, h as y };

//# sourceMappingURL=nodeToBlock-e66ZlC--.js.map